/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m6.232 20.165 7.036-7.35 2.48 2.59-8.365 4.858a1.003 1.003 0 0 1-1.023-.007l-.128-.091Zm6.327-8.092L5.85 19.08V5.065l6.709 7.008Zm4.192-2.896 3.277 1.903c.322.188.522.54.522.92s-.2.732-.522.92l-3.367 1.955-2.683-2.802 2.773-2.896ZM6.157 3.903a1.003 1.003 0 0 1 1.226-.167l8.455 4.911-2.57 2.684-7.11-7.428Z"
})), "0 0 24 24", "GooglePlay");